import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export default function AdminLoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-5 relative">
      {/* Background image */}
      <div
        aria-hidden
        className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url(/Admin%20Panel.webp)",
          filter: "brightness(0.85) saturate(1.05)",
        }}
      />
      <div
        aria-hidden
        className="fixed inset-0 -z-10"
        style={{ background: "rgba(0, 0, 0, 0.50)" }}
      />
      <div className="flex flex-col items-center mb-6">
        <img
          src="/care-for-flora-logo.png"
          alt="Care for Flora"
          width={180}
          style={{ height: "auto", filter: "drop-shadow(0 6px 22px rgba(76,175,80,0.45))" }}
          data-testid="admin-login-logo"
        />
        <p className="text-[10px] uppercase tracking-wider text-muted-soft mt-1">Admin Console</p>
      </div>

      <form onSubmit={submit} className="glass-card-strong w-full max-w-md p-7" data-testid="admin-login-card">
        <div className="flex items-center gap-2 mb-5">
          <Shield size={18} className="text-[#4CAF50]" />
          <h1 className="text-xl font-bold">Sign in</h1>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-soft">Email</label>
            <input
              data-testid="admin-email-input"
              className="glass-input mt-1"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-soft">Password</label>
            <input
              data-testid="admin-password-input"
              className="glass-input mt-1"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button data-testid="admin-login-submit" disabled={busy} className="btn-primary w-full mt-2">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
